<template>
    <v-form>
        <v-card>
            <v-toolbar dark color="primary">
                <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
                <slot name="header"></slot>
            </v-toolbar>
            <v-card-text>
                <v-container grid-list-md>
                    <v-layout wrap>
                        <v-flex xs12>
                            <v-text-field
                                v-model="value.name"
                                label="Configuration Name"
                                v-validate="'required'"
                                :error-messages="errors.first('name')"
                                name="name"
                                maxlength="50"
                                required
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                            <v-select
                                label="Type"
                                :items="configurationTypes"
                                v-model="value.type"
                                v-validate="'required'"
                                :error-messages="errors.first('type')"
                                name="type"
                                required
                            ></v-select>
                        </v-flex>
                        <v-flex xs12>
                            <v-select
                                label="Service Requirements"
                                item-value="id"
                                item-text="shortName"
                                :items="serviceRequirements"
                                v-model="value.serviceRequirements"
                                v-validate="'required'"
                                :error-messages="errors.collect('requirements')"
                                name="requirements"
                                required
                                multiple
                            ></v-select>
                        </v-flex>
                        <v-flex xs12 v-if="isContainerType">
                            <v-select
                                label="Container Sizes"
                                v-model="value.containerSizes"
                                name="container sizes"
                                :items="containerSizes"
                                item-value="id"
                                item-text="description"
                                v-validate="'required'"
                                :error-messages="errors.first('container sizes')"
                                required
                                multiple
                            ></v-select>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <slot name="actions"></slot>
                <v-btn
                    color="primary"
                    :disabled="disableSubmit || this.submitted"
                    @click="submit"
                >{{ !this.editing ? 'Save Changes' : 'Update' }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-form>
</template>
<script>
  import {ConfigurationType} from '../../models/enums';
  import ServiceRequirements from '../ServiceRequirements/ServiceRequirementsClient.vue';
  import FormValidation from '../FormValidation.vue';

  export default {
    props: {
      value: {
        required: true
      },
      serviceRequirements: {
        required: true
      },
      containerSizes: {
        required: true
      }
    },
    mixins: [FormValidation, ServiceRequirements],
    computed: {
      formTitle() {
        return !this.editing ? 'Add Configuration' : 'Edit Configuration';
      },
      editing() {
        return !!this.value.id;
      },
      isContainerType() {
        return this.value.type && this.value.type === ConfigurationType.Container;
      }
    },
    methods: {
      submitForm() {
        this.submitted = true;
        this.addOrUpdate();
      },
      addOrUpdate() {
        if (!this.editing) {
          this.$emit('add', {id: this.id, model: this.value});
        } else {
          this.$emit('edit', {model: this.value});
        }
      }
    },
    data() {
      return {
        id: '',
        submitted: false,
        configurationTypes: Object.keys(ConfigurationType)
          .map(key => ConfigurationType[key])
          .sort()
      };
    },
    watch: {
      value(val) {
        if (val.id) {
          this.id = val.id;
        } else {
          this.id = this.$uuid.v1();
        }
        this.submitted = false;
      }
    }
  };
</script>
